module.exports = __webpack_public_path__ + "static/media/iconTransmissionActive.faac4f2c.svg";